export default __webpack_public_path__ + "c7b51fc1080257c7115c98f3ad302c46.png";